<template>
  <!-- -->
  <div class="mobileViewStyle setting-page">
    <list-card label="基本信息" type="form">
      <data-column label="头像">
        <div class="user-icon">
          <img class="icon" v-if="userInfo.iconUrl" :src="userInfo.iconUrl" alt="头像" />
          <yq-icon class="icon" name="user" v-else/>
          <yq-icon class="arrow" name="element-ui_arrow-right"/>
        </div>
      </data-column>
      <data-input label="姓名" v-model="userInfo.userName" :disabled="true"/>
      <data-input label="手机号" v-model="userInfo.userPhone" :disabled="true"/>
    </list-card>

  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import util from "@/util/util";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import DataInput from "@/components/qywx/data/DataInput.vue";
import YqIcon from "@/components/YqIcon.vue";
import imageUtil from "@/util/imageUtil";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MySetting",
  components: {
    YqIcon,
    ListCard, DataInput, DataColumn
  },
  data() {
    return {
      userInfo: {},
      pageTitle: "",
    };
  },
  created() {
    this.pageTitle = document.title;
    document.title = "个人信息";
    util.getUserInfo().then(res => {
      res.iconUrl = imageUtil.getFileUrlSingle(res.iconUrl);
      res.address = "亚洲大区中国服务区四川省成都市双流区怡心街道华府大道1099号11栋12楼3号1105";
      this.userInfo = res;
    });

  },
  unmounted() {
    document.title = this.pageTitle;
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.setting-page{
  padding-top: 20px;
  .user-icon{
    display: inline-flex;
    align-items:  center;
    .icon {
      width: 60px;
      aspect-ratio: 1/1;
      border-radius: 50%;
      background: var(--yq-background-color);
      font-size: 40px;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--yq-border-color);
    }
    .arrow{
      margin-left: 10px;
      color: var(--yq-font-color-desc);
    }
  }

}
</style>